import {
    $, $$, $e, $each, FormSend,
    init,
    onClick,
    onClickHash,
    onReady,
    vAnimRun,
} from '../../core/cfjs'

init({
    loadedAnimAfter: '.header',
    onScrollThrottle: 10,
});

// onReady(() => {
//     // Цепочка анимаций через callback
//     if ($('.footer')) vAnimRun('.footer', () => vAnimRun('#hero'))
// })

// Бургер
onClick('header-burger', () => {
    bc.toggle('header-menu-active');
});

// Закрытие меню при переходе по якорю
onClickHash(() => {
    bc.remove('header-menu-active')
})

// --- COMPARISON SLIDER ---
$each(".comparison-slider", (slider) => {
    const after = $(".comparison-after", slider);
    const handle = $(".comparison-handle", slider);
    if (!after || !handle) return;

    let isDown = false;

    const move = (x) => {
        const rect = slider.getBoundingClientRect();
        let pos = ((x - rect.left) / rect.width) * 100;
        pos = Math.max(0, Math.min(100, pos));
        after.style.clipPath = `inset(0 ${100 - pos}% 0 0)`;
        handle.style.left = `${pos}%`;
    }

    $e(slider, 'mousedown', e => { isDown = true; move(e.clientX); });
    $e(window, 'mousemove', e => { if (isDown) move(e.clientX); });
    $e(window, 'mouseup', () => (isDown = false));

    $e(slider, 'touchstart', e => {
        isDown = true;
        move(e.touches[0].clientX);
    }, { passive: true });

    $e(slider, 'touchmove', e => {
        if (isDown) move(e.touches[0].clientX);
    }, { passive: true });

    $e(window, 'touchend', () => (isDown = false));
});

// --- QUIZ ---
const quiz = $('#quiz');

if (quiz) {
    let currentStep = 0;

    const resultPercentEl = $('.quiz-percent');
    const resultTitleEl = $('.quiz-result-title');

    // Рандомное целое число от 70 до 97
    const randomPercent = Math.floor(Math.random() * (97 - 70 + 1)) + 70;

    const updateResultText = () => {
        if (resultPercentEl) {
            resultPercentEl.textContent = `${randomPercent}%`;
        }

        if (resultTitleEl) {
            resultTitleEl.textContent =
                `${randomPercent}% клиенток имели похожий результат и достигли решения своей проблемы уже за 2 месяца работы`;
        }
    };

    const updateStep = () => {
        $each('.quiz-step', (step, index) => {
            step.classList.toggle('is-active', index === currentStep);
        });

        // Когда открывается результат
        if (currentStep === 3) {
            updateResultText();
        }
    };

    $each('.quiz-option input', (input) => {
        $e(input, 'change', () => {
            const btn = $('.btn-next', input.closest('.quiz-step'));
            btn?.classList.remove('btn-disabled');
        });
    });

    $each('.btn-next', (btn) => {
        $e(btn, 'click', () => {
            if (btn.classList.contains('btn-disabled')) return;

            currentStep++;
            updateStep();
        });
    });

    $each('.btn-back', (btn) => {
        $e(btn, 'click', () => {
            currentStep--;
            updateStep();
        });
    });

    $e(quiz, 'submit', (e) => {
        e.preventDefault();

        console.log('Quiz data:', Object.fromEntries(new FormData(quiz)));
    });
}
// --- GALLERY ---
const images = $$('.gallery-img');
const galleryModal = $('#gallery-modal');
if (galleryModal && images.length > 0) {
    const modalImg = $('.gallery-full', galleryModal);
    const btnNext = $('.gallery-next', galleryModal);
    const btnPrev = $('.gallery-prev', galleryModal);
    let currentIndex = 0;

    const updateImage = () => {
        if (modalImg) modalImg.src = images[currentIndex].src;
    }

    const openModal = () => {
        galleryModal.classList.add('is-active');
        updateImage();
    }

    const closeModal = () => galleryModal.classList.remove('is-active');

    $each(images, (img, index) => {
        $e(img, 'click', () => {
            currentIndex = index;
            openModal();
        });
    });

    $e(btnNext, 'click', () => {
        currentIndex = (currentIndex + 1) % images.length;
        updateImage();
    });

    $e(btnPrev, 'click', () => {
        currentIndex = (currentIndex - 1 + images.length) % images.length;
        updateImage();
    });

    $each(['.gallery-close', '.gallery-overlay'], (sel) => {
        $e($(sel, galleryModal), 'click', closeModal);
    });

    $e(window, 'keydown', (e) => {
        if (!galleryModal.classList.contains('is-active')) return;
        if (e.key === 'Escape') closeModal();
        if (e.key === 'ArrowRight') btnNext?.click();
        if (e.key === 'ArrowLeft') btnPrev?.click();
    });

    // Swipe
    let startX = 0;
    $e(galleryModal, 'touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    $e(galleryModal, 'touchend', e => {
        const diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) diff > 0 ? btnNext?.click() : btnPrev?.click();
    }, { passive: true });
}

// --- FAQ ---
$each('.faq-item', item => {
    $e($('.faq-trigger', item), 'click', () => {
        const isOpen = item.classList.contains('active');
        $each('.faq-item', i => i.classList.remove('active'));
        if (!isOpen) item.classList.add('active');
    });
});

// Dropdowns
$each('.header-dropdown-toggle', (btn) => {
    $e(btn, 'click', () => btn.closest('.header-dropdown')?.classList.toggle('is-open'));
});

// --- VIDEO MODAL ---
const videoOverlay = $('#video-overlay');
if (videoOverlay) {
    const iframe = $('iframe', videoOverlay);

    const toggleVideo = (state) => {
        videoOverlay.classList.toggle('is-open', state);
        body.style.overflow = state ? 'hidden' : '';
        if (!state && iframe) {
            const s = iframe.src;
            iframe.src = '';
            iframe.src = s;
        }
    };

    $e('#open-video-btn', 'click', () => toggleVideo(true));
    $e('#close-video-btn', 'click', () => toggleVideo(false));
    $e(videoOverlay, 'click', (e) => { if (e.target === videoOverlay) toggleVideo(false); });
    $e(window, 'keydown', (e) => { if (e.key === 'Escape') toggleVideo(false); });
}

$each('form', form=>{
    FormSend(form, {
        url: '/send.php',
        validate: form => form.name.value.length && form.contact.value.length && form['submit-checkbox'].checked,
        labels: {
            sending: 'Sending',
            success: 'Successfully sent',
            error: 'Message not sent',
        },
        selectorMsg: alert, 
        onSuccess: console.log,
        onError: console.error,
    })
})


const CORRECT_PASSWORD = 'coachGuide26D';
const STORAGE_KEY = 'guide_access';

function showDownload() {
  document.getElementById('password-block').style.display = 'none';
  document.getElementById('download-block').style.display = 'block';
}

if (localStorage.getItem(STORAGE_KEY) === 'granted') {
  showDownload();
}

document.querySelector('.btn-guide').addEventListener('click', checkPassword);

document.getElementById('passwordInput').addEventListener('keydown', function(e) {
  if (e.key === 'Enter') checkPassword();
});

function checkPassword() {
  const input = document.getElementById('passwordInput');
  const error = document.getElementById('error');

  if (input.value === CORRECT_PASSWORD) {
    localStorage.setItem(STORAGE_KEY, 'granted');
    showDownload();
  } else {
    error.style.display = 'block';
    input.value = '';
    input.focus();
  }
}
